import "./policy.css";

export default function Shipping() {

  return (
    <div className="policy-page">

      <div className="policy-hero">
        <h1>Shipping Policy</h1>
        <p>Fast and secure nationwide delivery.</p>
      </div>

      <div className="policy-container">

        <div className="policy-card">
          <h2>Processing Time</h2>

          <p>
            Orders are processed within 1-2 business days
            after successful payment confirmation.
          </p>
        </div>

        <div className="policy-card">
          <h2>Delivery Time</h2>

          <p>
            Standard shipping usually takes 3-5 business days
            depending on customer location.
          </p>
        </div>

        <div className="policy-card">
          <h2>Tracking Orders</h2>

          <p>
            Customers receive shipment tracking details
            immediately after dispatch.
          </p>
        </div>

      </div>

    </div>
  );
}